(() => {
  const DAY = 86400000;
  const GTA_CITIES = new Set(['toronto','north york','scarborough','etobicoke','east york','york','mississauga','brampton','caledon','bolton','caledon east','oakville','burlington','milton','halton hills','georgetown','acton','vaughan','woodbridge','maple','concord','thornhill','richmond hill','markham','unionville','stouffville','whitchurch stouffville','aurora','newmarket','east gwillimbury','holland landing','sharon','mount albert','georgina','keswick','sutton','king','king city','nobleton','schomberg','ajax','pickering','whitby','brooklin','oshawa','clarington','bowmanville','courtice','newcastle','uxbridge','scugog','port perry','brock','beaverton','cannington']);
  const SOUTHERN_ONTARIO_CITIES = new Set([...GTA_CITIES, ..."hamilton|stoney creek|dundas|ancaster|waterdown|flamborough|binbrook|grimsby|beamsville|lincoln|west lincoln|smithville|niagara falls|niagara on the lake|st catharines|saint catharines|thorold|welland|pelham|fonthill|port colborne|fort erie|ridgeway|wainfleet|kitchener|waterloo|cambridge|guelph|burlington|brantford|brant|paris|st george|ayr|new hamburg|wilmot|wellesley|woolwich|elmira|elora|fergus|centre wellington|erin|rockwood|puslinch|orangeville|shelburne|grand valley|dufferin|caledonia|cayuga|dunnville|haldimand|simcoe|port dover|delhi|waterford|norfolk|tillsonburg|woodstock|ingersoll|oxford|london|st thomas|saint thomas|aylmer|strathroy|mount brydges|lucan|ilderton|dorchester|komoka|sarnia|petrolia|forest|grand bend|lambton shores|stratford|st marys|saint marys|listowel|mitchell|stirling|exeter|goderich|clinton|wingham|walkerton|hanover|durham|mount forest|harriston|palmerston|arthur|owen sound|meaford|thornbury|the blue mountains|collingwood|wasaga beach|stayner|creemore|shelburne|dundalk|flesherton|markdale|chesley|paisley|port elgin|southampton|sauble beach|wiarton|tobermory|kincardine|lucknow|windsor|lasalle|tecumseh|lakeshore|essex|amherstburg|kingsville|leamington|harrow|belle river|chatham|chatham kent|wallaceburg|blenheim|ridgetown|tilbury|dresden|bothwell|barrie|innisfil|bradford|bradford west gwillimbury|alliston|new tecumseth|beeton|tottenham|angus|essa|orillia|oro medonte|midland|penetanguishene|tiny|tay|victoria harbour|coldwater|elmvale|springwater|severn|washago|gravenhurst|bracebridge|huntsville|muskoka|muskoka lakes|bala|port carling|baysville|dwight|dorset|parry sound|severn bridge|burks falls|sundridge|south river|kearney|magnetawan|peterborough|kawartha lakes|lindsay|bobcaygeon|fenelon falls|coboconk|omemee|millbrook|cavan monaghan|lakefield|selwyn|havelock|norwood|campbellford|trenton|quinte west|belleville|brighton|cobourg|port hope|colborne|grafton|bancroft|haliburton|minden|apsley|tweed|madoc|marmora|deseronto|napanee|greater napanee|picton|prince edward county|wellington|bloomfield|kingston|gananoque|brockville|prescott|cornwall|smiths falls|perth|carleton place|almonte|mississippi mills|arnprior|renfrew|pembroke|petawawa|deep river|eganville|barrys bay|killaloe|ottawa|kanata|nepean|orleans|gloucester|stittsville|manotick|osgoode|greely|richmond|carp|constance bay|kemptville|north grenville|russell|embrun|casselman|rockland|clarence rockland|hawkesbury|alexandria|vankleek hill|winchester|chesterville|morrisburg|ingleside|long sault".split('|')]);
  const dateKey = date => date.toISOString().slice(0, 10);
  const plusDays = (date, days) => new Date(date.getTime() + days * DAY);
  const cleanName = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();
  const parseDates = value => new Set(String(value || '').split(/[\s,;]+/).filter(x => /^\d{4}-\d{2}-\d{2}$/.test(x)));

  function torontoClock(now) {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(now).map(part => [part.type, part.value]));
    return { date: new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), 12)), hour: Number(parts.hour), minute: Number(parts.minute) };
  }

  function nthMonday(year, month, nth) {
    const first = new Date(Date.UTC(year, month, 1, 12));
    return plusDays(first, (8 - first.getUTCDay()) % 7 + 7 * (nth - 1));
  }

  function easter(year) {
    const a = year % 19, b = Math.floor(year / 100), c = year % 100, d = Math.floor(b / 4), e = b % 4;
    const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    const value = h + l - 7 * m + 114;
    return new Date(Date.UTC(year, Math.floor(value / 31) - 1, value % 31 + 1, 12));
  }

  function holidayDates(year, country) {
    const days = [];
    const fixed = (month, day, canadian = false) => {
      const date = new Date(Date.UTC(year, month, day, 12));
      days.push(date);
      if (date.getUTCDay() === 0) days.push(plusDays(date, 1));
      if (canadian && date.getUTCDay() === 6) days.push(plusDays(date, 2));
      return days.at(-1);
    };
    fixed(0, 1, country === 'CA');
    days.push(nthMonday(year, 8, 1));
    if (country === 'CA') {
      const spring = easter(year);
      days.push(plusDays(spring, -2), plusDays(spring, 1));
      let victoria = new Date(Date.UTC(year, 4, 24, 12));
      while (victoria.getUTCDay() !== 1) victoria = plusDays(victoria, -1);
      days.push(victoria, nthMonday(year, 7, 1), nthMonday(year, 9, 2));
      fixed(6, 1, true); fixed(8, 30, true); fixed(10, 11, true);
      const christmas = fixed(11, 25, true);
      const boxing = new Date(Date.UTC(year, 11, 26, 12));
      days.push(boxing);
      let observed = boxing;
      while (observed.getUTCDay() === 0 || observed.getUTCDay() === 6 || dateKey(observed) === dateKey(christmas)) observed = plusDays(observed, 1);
      days.push(observed);
    } else {
      days.push(nthMonday(year, 0, 3), nthMonday(year, 1, 3), nthMonday(year, 9, 2));
      let memorial = new Date(Date.UTC(year, 4, 31, 12));
      while (memorial.getUTCDay() !== 1) memorial = plusDays(memorial, -1);
      days.push(memorial);
      const november = new Date(Date.UTC(year, 10, 1, 12));
      days.push(plusDays(november, (11 - november.getUTCDay()) % 7 + 21));
      fixed(5, 19); fixed(6, 4); fixed(10, 11); fixed(11, 25);
    }
    return new Set(days.map(dateKey));
  }

  function addBusinessDays(date, count, country, closures) {
    let result = new Date(date), added = 0;
    const calendar = new Map();
    const closed = day => {
      const year = day.getUTCFullYear();
      if (!calendar.has(year)) calendar.set(year, new Set([...holidayDates(year, 'CA'), ...(country === 'US' ? holidayDates(year, 'US') : [])]));
      return day.getUTCDay() === 0 || day.getUTCDay() === 6 || closures.has(dateKey(day)) || calendar.get(year).has(dateKey(day));
    };
    for (let guard = 0; added < count && guard < 500; guard++) { result = plusDays(result, 1); if (!closed(result)) added++; }
    return result;
  }

  function locationFromGeo(data) {
    const country = String(data?.country_code || '').toUpperCase();
    const city = String(data?.city || '').trim().slice(0, 80);
    const province = cleanName(data?.region);
    const latitude = Number.parseFloat(data?.latitude);
    const longitude = Number.parseFloat(data?.longitude);
    const inSouthernArea = Number.isFinite(latitude) && Number.isFinite(longitude)
      && latitude >= 41.5 && latitude < 46 && longitude >= -83.5 && longitude <= -74
      && !(latitude > 45.5 && longitude < -80.5);
    const local = country === 'CA' && ['ontario', 'on'].includes(province)
      && (SOUTHERN_ONTARIO_CITIES.has(cleanName(city)) || inSouthernArea);
    return { region: local ? 'GTA' : country, city, source: 'ip' };
  }

  function deliveryEstimate(now, region, options = {}) {
    const clock = torontoClock(now), closures = parseDates(options.closedDates), gtaClosures = parseDates(options.gtaClosedDates);
    const cutoff = Math.min(23, Math.max(0, Number(options.cutoff ?? 18)));
    if (region === 'GTA') {
      const localClosures = new Set([...closures, ...gtaClosures]);
      const today = clock.date;
      const closedToday = today.getUTCDay() === 0 || today.getUTCDay() === 6
        || localClosures.has(dateKey(today)) || holidayDates(today.getUTCFullYear(), 'CA').has(dateKey(today));
      const before = clock.hour < cutoff && !closedToday;
      const base = before ? today : addBusinessDays(today, 1, 'CA', localClosures);
      const value = (key, fallback) => Math.max(0, Math.min(60, Number.isFinite(Number(options[key])) ? Number(options[key]) : fallback));
      const processMin = value('processingMin', 2), processMax = Math.max(processMin, value('processingMax', 3));
      const transitMax = GTA_CITIES.has(cleanName(options.city)) ? 2 : 4;
      const start = addBusinessDays(addBusinessDays(base, processMin, 'CA', localClosures), 1, 'CA', localClosures);
      const end = addBusinessDays(addBusinessDays(base, processMax, 'CA', localClosures), transitMax, 'CA', localClosures);
      return { kind: 'gta', start, end, transitMax, cutoff, cutoffState: closedToday ? 'closed' : before ? 'before' : 'after' };
    }
    if (!['CA', 'US'].includes(region)) return { kind: 'unknown' };
    const value = (key, fallback) => Math.max(0, Math.min(60, Number.isFinite(Number(options[key])) ? Number(options[key]) : fallback));
    const processMin = value('processingMin', 2), processMax = Math.max(processMin, value('processingMax', 3));
    const transitMin = region === 'US' ? value('usaMin', 7) : value('canadaMin', 3);
    const transitMax = Math.max(transitMin, region === 'US' ? value('usaMax', 21) : value('canadaMax', 7));
    let base = clock.date;
    if (clock.hour >= cutoff && base.getUTCDay() > 0 && base.getUTCDay() < 6) base = plusDays(base, 1);
    const start = addBusinessDays(addBusinessDays(base, processMin, 'CA', closures), transitMin, region, closures);
    const end = addBusinessDays(addBusinessDays(base, processMax, 'CA', closures), transitMax, region, closures);
    return { kind: 'standard', start, end };
  }

  function shippingState(variant, quantity = 1) {
    if (!variant?.shipping) return 'not-shipped';
    if (!variant.available) return 'unavailable';
    if (!variant.readyToShip || (variant.stockForEstimate !== null && Number(variant.stockForEstimate) < quantity)) return 'backorder';
    return 'ready';
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { torontoClock, holidayDates, addBusinessDays, locationFromGeo, deliveryEstimate, shippingState };
    return;
  }
  if (customElements.get('sf-delivery-estimate')) return;
  const configElement = document.getElementById('sf-delivery-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent), labels = config.labels;
  const ZONE_VERSION = 2;
  const CACHE_KEY = 'sf-delivery-destination-v1', TTL = 4 * 60 * 60 * 1000;
  const subscribers = new Set();
  const words = (text, values = {}) => String(text || '').replace(/\[([a-z]+)\]/g, (_, key) => values[key] ?? '');
  let locationState = { region: config.country || '', city: '', source: 'market' }, saved, detecting;
  try { saved = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null'); } catch (_) {}
  if (saved && (saved.source === 'manual' || saved.zoneVersion === ZONE_VERSION) && Date.now() - saved.timestamp < TTL && ['GTA', 'CA', 'US'].includes(saved.region)) locationState = { region: saved.region, city: String(saved.city || '').slice(0, 80), source: saved.source === 'manual' ? 'manual' : saved.city ? 'ip' : 'market' };
  function saveLocation(value) {
    locationState = value;
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ ...value, zoneVersion: ZONE_VERSION, timestamp: Date.now() })); } catch (_) {}
    subscribers.forEach(component => component.render());
  }
  async function detectLocation(force = false) {
    if (detecting || config.autoLocation === false || (!force && locationState.source !== 'market')) return detecting;
    const requestedLocation = locationState;
    detecting = (async () => {
      const controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 4000);
      try {
        const response = await fetch('https://get.geojs.io/v1/ip/geo.json', { credentials: 'omit', referrerPolicy: 'no-referrer', signal: controller.signal });
        if (!response.ok) return;
        const detected = locationFromGeo(await response.json());
        if (locationState !== requestedLocation) return;
        if (detected.region) saveLocation(detected);
      } catch (_) {} finally { clearTimeout(timeout); }
    })();
    try { return await detecting; } finally { detecting = null; }
  }

  const prettyDate = date => new Intl.DateTimeFormat(config.locale || 'en', { month: 'short', day: 'numeric', timeZone: 'UTC' }).format(date);
  const prettyTime = hour => new Intl.DateTimeFormat(config.locale || 'en', { hour: 'numeric', timeZone: 'UTC' }).format(new Date(Date.UTC(2026, 0, 1, hour)));

  class Delivery extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.root = this.closest('[data-product-root]');
      this.querySelector('[data-delivery-apply]').addEventListener('click', () => {
        const region = this.querySelector('[data-delivery-region]').value;
        if (!['GTA', 'CA', 'US'].includes(region)) return;
        saveLocation({ region, city: '', source: 'manual' });
        this.querySelector('details').open = false;
        this.querySelector('summary').focus();
      }, { signal });
      this.querySelector('[data-delivery-detect]')?.addEventListener('click', async event => {
        const button = event.currentTarget;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        try { await detectLocation(true); }
        finally { button.disabled = false; button.removeAttribute('aria-busy'); }
      }, { signal });
      if (this.root) {
        this.root.addEventListener('sf:variant-updated', event => this.updateVariant(event.detail.variant), { signal });
        this.root.addEventListener('change', event => { if (event.target.matches('[name=quantity]')) this.render(); }, { signal });
        this.root.addEventListener('click', event => { if (event.target.closest('[data-quantity-delta]')) requestAnimationFrame(() => this.render()); }, { signal });
      }
      this.render(); subscribers.add(this);
      this.timer = setInterval(() => { if (!document.hidden) this.render(); }, 30000);
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.render(); }, { signal });
      window.addEventListener('pageshow', () => this.render(), { signal });
      if (!this.closest('dialog') || this.closest('dialog').open) detectLocation();
      else {
        this.observer = new MutationObserver(() => { if (this.closest('dialog')?.open) detectLocation(); });
        this.observer.observe(this.closest('dialog'), { attributes: true, attributeFilter: ['open'] });
      }
    }
    updateVariant(variant) {
      this.dataset.shipping = String(variant.shipping);
      this.dataset.available = String(variant.available);
      this.dataset.ready = String(variant.readyToShip);
      if (variant.stockForEstimate === null) delete this.dataset.stock; else this.dataset.stock = String(variant.stockForEstimate);
      this.render();
    }
    render() {
      const quantity = Number(this.root?.querySelector('.sf-main-add-form [name=quantity]')?.value || 1);
      const state = shippingState({ shipping: this.dataset.shipping === 'true', available: this.dataset.available === 'true', readyToShip: this.dataset.ready === 'true', stockForEstimate: this.dataset.stock === undefined ? null : Number(this.dataset.stock) }, quantity);
      this.hidden = state === 'not-shipped';
      if (this.hidden) return;
      const region = locationState.region;
      this.dataset.region = region;
      const destination = locationState.city || (region === 'GTA' ? labels.gta : region === 'US' ? labels.usa : region === 'CA' ? labels.canada : '');
      const destinationLabel = this.querySelector('[data-delivery-destination]');
      destinationLabel.textContent = destination ? words(locationState.source === 'ip' && locationState.city ? labels.near : labels.to, { place: destination }) : labels.unknown;
      destinationLabel.title = destinationLabel.textContent;
      const select = this.querySelector('[data-delivery-region]');
      if (!this.querySelector('details').open && ['GTA', 'CA', 'US'].includes(region)) select.value = region;
      const arrival = this.querySelector('[data-delivery-arrival]'), cutoff = this.querySelector('[data-delivery-cutoff]'), note = this.querySelector('[data-delivery-note]');
      cutoff.textContent = ''; note.textContent = labels.standardNote;
      if (state !== 'ready') { arrival.textContent = state === 'unavailable' ? labels.unavailable : labels.backorder; return; }
      const estimate = deliveryEstimate(new Date(), region, { ...config, city: locationState.city });
      if (estimate.kind === 'gta') {
        arrival.textContent = words(labels.between, { start: prettyDate(estimate.start), end: prettyDate(estimate.end) });
        note.textContent = words(labels.gtaNote, { days: '1–' + estimate.transitMax });
      } else if (estimate.kind === 'standard') {
        arrival.textContent = words(labels.between, { start: prettyDate(estimate.start), end: prettyDate(estimate.end) });
      } else arrival.textContent = labels.unknown;
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; clearInterval(this.timer); this.observer?.disconnect(); subscribers.delete(this); }
  }

  function renderHours(root) {
    const today = (torontoClock(new Date()).date.getUTCDay() + 6) % 7;
    const hours = String(config.hours || '').split('|');
    const readable = value => {
      const match = /^(\d{1,2}):(\d{2})-(\d{1,2}):(\d{2})$/.exec(String(value || '').trim());
      if (!match) return value || labels.closed;
      const time = (hour, minute) => new Intl.DateTimeFormat(config.locale || 'en', { hour: 'numeric', minute: Number(minute) ? '2-digit' : undefined, timeZone: 'UTC' }).format(new Date(Date.UTC(2026, 0, 1, Number(hour), Number(minute))));
      return time(match[1], match[2]) + ' – ' + time(match[3], match[4]);
    };
    root.querySelectorAll('[data-hours-day]').forEach(row => { const day = Number(row.dataset.hoursDay); row.classList.toggle('is-today', day === today); row.querySelector('[data-hours-value]').textContent = readable(hours[day]); });
    const current = root.querySelector('[data-pickup-today]');
    if (current) current.textContent = words(labels.todayHours, { hours: readable(hours[today]) });
  }

  class Pickup extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.addEventListener('click', event => {
        const opener = event.target.closest('[data-open-pickup]');
        if (opener) { const dialog = this.querySelector('dialog'); this.opener = opener; renderHours(this); if (dialog && !dialog.open) dialog.showModal(); }
        const dialog = this.querySelector('dialog');
        if (event.target.closest('[data-close-pickup]') || (dialog && event.target === dialog)) dialog?.close();
        if (event.target.closest('[data-retry-pickup]')) this.load(this.dataset.variantId);
      }, { signal });
      this.addEventListener('close', () => this.opener?.focus({ preventScroll: true }), { signal, capture: true });
      this.closest('[data-product-root]')?.addEventListener('sf:variant-updated', event => {
        this.hidden = !event.detail.variant.shipping;
        if (!this.hidden) this.load(event.detail.variant.id);
      }, { signal });
      renderHours(this);
    }
    async load(id) {
      this.dataset.variantId = String(id);
      this.request?.abort();
      const request = new AbortController(); this.request = request;
      this.classList.add('sf-pickup-loading'); this.setAttribute('aria-busy', 'true');
      const requested = String(id), timer = setTimeout(() => request.abort(), 8000);
      try {
        const url = new URL((config.root || '/') + 'variants/' + encodeURIComponent(id) + '/', location.origin);
        url.searchParams.set('section_id', 'sf-pickup-availability');
        const response = await fetch(url, { signal: request.signal, headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Pickup availability unavailable');
        const replacement = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-pickup-content]');
        if (!replacement) throw new Error('Pickup availability unavailable');
        if (this.request !== request || this.dataset.variantId !== requested || !this.isConnected) return;
        this.querySelector('dialog')?.close(); this.replaceChildren(replacement); renderHours(this);
      } catch (error) {
        if (this.request !== request || this.dataset.variantId !== requested || !this.isConnected) return;
        const fallback = document.createElement('div'); fallback.className = 'sf-pickup-card';
        const retry = document.createElement('button'); retry.type = 'button'; retry.className = 'sf-pickup-card__link'; retry.dataset.retryPickup = ''; retry.textContent = this.dataset.retryLabel;
        fallback.textContent = this.dataset.errorLabel + ' '; fallback.append(retry); this.replaceChildren(fallback);
      } finally {
        clearTimeout(timer);
        if (this.request === request) { this.classList.remove('sf-pickup-loading'); this.removeAttribute('aria-busy'); }
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; this.request?.abort(); this.querySelector('dialog')?.close(); }
  }

  customElements.define('sf-delivery-estimate', Delivery);
  customElements.define('sf-pickup', Pickup);
})();


